import React from "react";
import { IconProps } from "antd/lib/icon";
import { Icon } from "antd/es";

const IconWrapper: React.FC<IconProps> = (props) => {
  return React.createElement(Icon as any, props);
};

export default IconWrapper;
